import { Delete } from "lucide-react";
import { cn } from "@/lib/utils";

interface PinPadProps {
  value: string;
  onChange: (next: string) => void;
  length?: number;
  disabled?: boolean;
}

export const PinPad = ({ value, onChange, length = 4, disabled }: PinPadProps) => {
  const press = (k: string) => {
    if (disabled) return;
    if (k === "del") {
      onChange(value.slice(0, -1));
      return;
    }
    if (value.length >= length) return;
    onChange((value + k).replace(/[^0-9]/g, ""));
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex gap-3">
        {Array.from({ length }).map((_, i) => (
          <div
            key={i}
            className={cn(
              "h-4 w-4 rounded-full border-2 transition-colors",
              i < value.length ? "bg-primary border-primary" : "border-muted-foreground/40",
            )}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3 w-full max-w-xs">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((k) => (
          <PadButton key={k} onClick={() => press(k)} disabled={disabled}>
            {k}
          </PadButton>
        ))}
        <div />
        <PadButton onClick={() => press("0")} disabled={disabled}>
          0
        </PadButton>
        <PadButton onClick={() => press("del")} disabled={disabled} aria-label="Delete">
          <Delete className="h-5 w-5 mx-auto" />
        </PadButton>
      </div>
    </div>
  );
};

const PadButton = ({
  children,
  onClick,
  disabled,
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="h-14 rounded-2xl bg-secondary/70 hover:bg-secondary active:scale-95 transition-all font-display text-2xl font-semibold disabled:opacity-50"
    {...rest}
  >
    {children}
  </button>
);
